import React, { useEffect, useState } from 'react'
import { Pagination, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchNewsData, fetchNewsPagination } from '../../../../redux/action/homePage/news/homeNews'
import MainLoading from '../../../../utils/MainLoading'
import CreateNews from './CreateNews'
import moment from "moment-jalaali";
import DeleteModal from './Modals/DeleteModal'
import EditModal from './Modals/EditModal'
import renderHTML from 'react-render-html';
import '../style.scss'
import default_image_url from '../../../../redux/api/API'
import { useTranslation } from 'react-i18next'

const News = () => {
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')
    const [createNewNews, setCreateNewNews] = useState(false)
    const [show, setShow] = useState(true);
    const dispatch = useDispatch()
    const newsData = useSelector(state => state.newsData)
    const [data, setData] = useState({
        title: '',
        description: '',
    })
    const [modal, setModal] = useState({
        delete: false,
        edit: false,
        id: ''
    })

    const handleClick = () => { setShow(false) }

    const handleDelete = (id) => { {
        setModal({  delete: true, id: id })
        setShow(true)
    }}

    const handleEdit = (id) => { {
        setModal({ edit: true, id: id })
        setShow(true)
    }}

    const handleCreateNews = () => {
        setCreateNewNews(true)
        window.scrollTo(0, 0)
    }

    const closeCreateNews = () => {
        setCreateNewNews(false)
        window.scrollTo(0, 0)
    }

    useEffect(() => {
        if(!newsData.news.data) {
            dispatch(fetchNewsData())
        }
    }, [])

    useEffect(() => {
        setData({
            title: newsData.news.title ? newsData.news.title: '' ,
            address: newsData.news.description ? newsData.news.description: ''
        })
    }, [newsData.news])

    const handlePaginate = (e) => {
        e.preventDefault()
        dispatch(fetchNewsPagination(e.target.href))
    }

    const update = () => {
        setTimeout(function(){
            dispatch(fetchNewsData())
        }, 1000)
        setCreateNewNews(false)
        setShow(false)
        window.scrollTo(0, 0)
    }

    return (
        <div className='mt-5'>
            {newsData.loading ? 
                <MainLoading />
            :
                createNewNews ?
                    <CreateNews update={update} close={closeCreateNews} />
                :
                    <>
                    {newsData.news.data &&
                        newsData.news.data.length ?
                            <>
                                <Table bordered responsive>
                                    <thead>
                                        <tr>
                                            <th className='col-lg-2'> {t("picture")} </th>
                                            <th className='col-lg-2'> {t("title")} </th>
                                            <th className='col-lg-2'> {t("text")} </th>
                                            <th className='col-lg-2'> {t("last update")} </th>
                                            <th className='col-lg-2 text-center'> {t("delete")} </th>
                                            <th className='col-lg-2 text-center'> {t("management")} </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {newsData.news.data.map(news => (
                                            <tr key={news.id}>
                                                <td className='text-center'> {news.image ? <img src={default_image_url+news.image.path} alt="news" style={{width: '90px'}} /> : <span style={{fontSize: '.8rem'}}>{t("no image")}</span>}</td>
                                                <td> {news.title} </td>
                                                <td className="dashboard_news_item">{renderHTML(news.description)} </td>
                                                <td>
                                                    {lang === 'en' ?
                                                        news.created_at.substr(11, 5)+' - '+news.created_at && news.created_at.substr(0, 10)
                                                    :
                                                        news.created_at.substr(11, 5)+' - '+moment(news.created_at && news.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                                    }
                                                </td>
                                                <td className='text-center'><button className='btn btn-danger btn-sm px-3' onClick={id => handleDelete(news.id)}>{t("delete")}</button></td>
                                                <td className='text-center'><button className='btn btn-warning btn-sm px-3' onClick={id => handleEdit(news.id)}>{t("edit")}</button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <div className='pagination_container mt-3'>
                                    <Pagination>
                                        {newsData.news.links ? newsData.news.links.map(link => (
                                            <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                                                {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                                            </Pagination.Item>
                                        )) : ''}
                                    </Pagination>
                                </div>
                            </>
                        :
                            <h6 className='text-center'>{t("No news has been recorded")}</h6>
                    }
                        
                        <div className="col-12 create_btn my-5 d-flex justify-content-end">
                            <button className="btn btn-success" onClick={handleCreateNews}> {t("create news")} <i className="fa fa-plus"></i></button>
                        </div>
                    </>
            }

            {modal.delete && <DeleteModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.edit && <EditModal id={modal.id} show={show} handleClick={handleClick} update={update} />}

        </div>
    )
}

export default News
